export const environment = {
    production: true,
     apiBaseUrl: 'https://api.kapitalnex.com'
  };
  